import { CloseIcon, InfoIcon } from '../assets/svgImages';
import { SHOW_CUSTOMER_BANNER } from '../constant/constant';
import { BannerProps } from '../interface/interface';

export const WelcomeBanner = ({
  hideBanner,
  handleBannerClose,
  className,
  nativeView,
}: BannerProps) => {
  const supportBanner = () => {
    return (
      <p className="text-xs md:text-base text-primary-blue-500 ml-3">
        <span className="font-semibold">
          Thank you for choosing our new online ordering platform!{' '}
        </span>
        <span>
          For any help or support, feel free to reach out to our team at{' '}
          <a className="underline" href="tel:1800123687">
            1800 123 687
          </a>
        </span>
      </p>
    );
  };

  const customBanner = () => {
    return (
      <p className="text-xs md:text-base text-primary-blue-500 ml-3 space-y-1">
        {/* <span>
          Please note:{' '}
          <span className="font-semibold"> Monday, 6th October </span>
          is a public holiday across multiple states of Australia. Postage delays
          may occur. Thank you for your understanding. For any help or support,
          feel free to reach out to our team at {' '}
          <a className="underline" href="tel:1800123687">
            1800 123 687.
          </a>
        </span> */}
        {/* <div>
          Happy Holidays! Please click{' '}
          <span className="font-semibold">
            <a href="https://monivearoad.com.au/holiday-hours/" target="_blank">
              HERE
            </a>
          </span>{' '}
          to see our holiday opening hours and order cut-off times. For any help
          or support, feel free to reach out on{' '}
          <a className="underline" href="tel:1800123687">
            1800 123 687
          </a>
          .
        </div> */}
        {/* <div>
          <span className="font-semibold">Australia Day Notice: </span>We will
          be closed on{' '}
          <span className="font-semibold">Monday 26th January </span> for the
          national public holiday. We will reopen on{' '}
          <span className="font-semibold">Tuesday 27th January. </span>
          Please expect delivery delays during this time.
        </div> */}

        {/* <div>
          <span className="font-semibold">The Monivea Road App is here! </span>
          <span>
            Available to download on{' '}
            <a className="underline" href={APP_STORE_URL}>
              iOS{' '}
            </a>
            and{' '}
            <a className="underline" href={PLAY_STORE_URL}>
              Android
            </a>
            .{' '}
          </span>
          For any support, please call our friendly team on{' '}
          <a className="underline" href="tel:1800123687">
            1800 123 687
          </a>
          .
        </div> */}
        <div>
          Interested in our{' '}
          <span className="font-semibold">non-script range</span> but unsure
          where to start?{' '}
          <a
            className="underline"
            target="_blank"
            href={
              'https://outlook.office.com/book/MoniveaRoadNaturopath@atlus.com.au/s/ugdsWAyrJE6C_GYAQrOhXQ2?ismsaljsauthenabled'
            }
          >
            Book a complimentary
          </a>{' '}
          chat with our naturopath today! For any support, please call our
          friendly team on{' '}
          <a className="underline" href="tel:1800123687">
            1800 123 687
          </a>
          .
        </div>
      </p>
    );
  };

  return (
    <div
      className={`bg-secondary-pink-100 px-4 py-3 md:py-4 w-full flex justify-between items-center ${hideBanner ? 'hidden' : 'block'} ${className}`}
    >
      <div className="flex items-center w-11/12 mx-auto">
        <InfoIcon className="w-6 hidden md:block fill-[#D15F9B]" />
        {!SHOW_CUSTOMER_BANNER && supportBanner()}
        {SHOW_CUSTOMER_BANNER && customBanner()}
      </div>
      <div>
        <CloseIcon
          className={`w-3.5 cursor-pointer fill-primary-blue-500 ${nativeView ? '-mt-5' : ''}`}
          onClick={handleBannerClose}
        />
      </div>
    </div>
  );
};
